import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, Text, Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import axios from 'axios';

const DashboardPanteones = () => {
  const [solicitudes, setSolicitudes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-panteon`)
      .then(res => setSolicitudes(res.data))
      .catch(() => setSolicitudes([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner size="xl" color="blue.500" />;

  const total = solicitudes.length;
  const totalCosto = solicitudes.reduce((acc, s) => acc + Number(s.costo || 0), 0);

  const tipos = solicitudes.reduce((acc: any, curr) => {
    const key = curr.tipo || 'Desconocido';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(tipos).map(([name, value]) => ({
    name,
    value,
  }));

  const colors = ['#2B6CB0', '#9F7AEA', '#38A169', '#DD6B20', '#E53E3E'];

  return (
    <Box p={6}>
      <Flex justify="center" mb={6}>


        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Distribución por Tipo
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>

      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total de Solicitudes</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total Recaudado</StatLabel>
            <StatNumber>${totalCosto.toFixed(2)}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Tipos Registrados</StatLabel>
            <StatNumber>{Object.keys(tipos).length}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardPanteones;
